module.exports = __webpack_public_path__ + "static/media/spinner.1e2831b7.gif";